import React, { useState } from 'react';
import GraveDetailTable from './GraveDetailTable';
import { Button, Grid } from '@mui/material';

const GraveDetailReport = () => {
  // כאן נמצא את הדאטה
  const cemeteries = [
    { id: 1, name: 'בית עלמין א' },
    { id: 2, name: 'בית עלמין ב' },
    { id: 3, name: 'בית עלמין ג' }
  ];

  const blocks = [
    { id: 1, name: 'גוש 1', cemeteryId: 1 },
    { id: 2, name: 'גוש 2', cemeteryId: 1 },
    { id: 3, name: 'גוש 1', cemeteryId: 2 },
    { id: 4, name: 'גוש 2', cemeteryId: 2 }
  ];

  const plots = [
    { id: 1, name: 'חלקה 1', blockId: 1 },
    { id: 2, name: 'חלקה 2', blockId: 1 },
    { id: 3, name: 'חלקה 1', blockId: 2 },
    { id: 4, name: 'חלקה 2', blockId: 2 },
    { id: 5, name: 'חלקה 1', blockId: 3 },
    { id: 6, name: 'חלקה 2', blockId: 3 }
  ];

  const areaGraves = [
    { id: 1, name: 'קבר 1', plotId: 1 },
    { id: 2, name: 'קבר 2', plotId: 2 },
    { id: 3, name: 'קבר 3', plotId: 2 },
    { id: 4, name: 'קבר 4', plotId: 1 },
    { id: 5, name: 'קבר 5', plotId: 1 },
    { id: 6, name: 'קבר 6', plotId: 6 },
    { id: 7, name: 'קבר 7', plotId: 6 },
    { id: 8, name: 'קבר 8', plotId: 6 }
  ];

  const graves = [
    { id: 1, name: 'א', areaGraveId: 1, graveStatus: 'free' },
    { id: 2, name: 'א', areaGraveId: 2, graveStatus: 'burial' },
    { id: 3, name: 'א', areaGraveId: 2, graveStatus: 'burial' },
    { id: 4, name: 'א', areaGraveId: 1, graveStatus: 'purchase' },
    { id: 5, name: 'א', areaGraveId: 1, graveStatus: 'free' },
    { id: 6, name: 'א', areaGraveId: 6, graveStatus: 'burial' },
    { id: 7, name: 'א', areaGraveId: 6, graveStatus: 'burial' },
    { id: 8, name: 'א', areaGraveId: 6, graveStatus: 'purchase' },
    { id: 9, name: 'ב', areaGraveId: 2, graveStatus: 'burial' },
    { id: 10, name: 'ב', areaGraveId: 1, graveStatus: 'purchase' },
    { id: 11, name: 'ב', areaGraveId: 1, graveStatus: 'free' },
    { id: 12, name: 'ב', areaGraveId: 6, graveStatus: 'burial' },
    { id: 13, name: 'ב', areaGraveId: 6, graveStatus: 'burial' },
    { id: 14, name: 'ב', areaGraveId: 6, graveStatus: 'purchase' },
  ];

  const handlePrint = () => {
    console.log('הדפסה');
  };

  const handleExportExcel = () => {
    console.log('ייצוא לאקסל');
  };

  const handleExportPDF = () => {
    console.log('ייצוא ל-PDF');
  };

  const handleExpandAll = () => {
    console.log('הרחב הכל');
  };

  const handleCollapseAll = () => {
    console.log('צמצם הכל');
  };

  return (
    <div>
      <Grid container spacing={2} style={{ marginBottom: '20px' }}>
        <Grid item>
          <Button variant="contained" onClick={handlePrint}>הדפסה</Button>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={handleExportExcel}>ייצוא לאקסל</Button>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={handleExportPDF}>ייצוא ל-PDF</Button>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={handleExpandAll}>הרחב הכל</Button>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={handleCollapseAll}>צמצם הכל</Button>
        </Grid>
      </Grid>

      <GraveDetailTable
        cemeteries={cemeteries}
        blocks={blocks}
        plots={plots}
        areaGraves={areaGraves}
        graves={graves}
      />
    </div>
  );
};

export default GraveDetailReport;
